<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 49 39"
    fill="none"
  >
    <path
      d="M25.0391 38.4413C29.7084 32.3267 36.9377 32.3293 42.1071 28.6333C50.4711 22.656 49.8204 8.02 44.4164 1.0198e-06C42.3017 15.0867 25.0391 11.2573 25.0391 38.4413Z"
      fill="url(#paint0_linear_5509_1666)"
    />
    <mask
      id="mask0_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="25"
      y="18"
      width="23"
      height="21"
    >
      <path d="M25.0399 18.2093H47.9944V38.44H25.0399V18.2093Z" fill="white" />
    </mask>
    <g mask="url(#mask0_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.0396 38.4405C29.7089 32.3272 36.9369 32.3285 42.1062 28.6339C45.3182 26.3379 47.1996 22.7659 47.9942 18.7819C39.8489 16.8219 31.3276 19.9899 26.4409 26.7952C25.5649 29.9125 25.0396 33.7045 25.0396 38.4392"
          fill="#6941C6"
        />
      </g>
    </g>
    <mask
      id="mask1_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="25"
      y="0"
      width="24"
      height="39"
    >
      <path d="M25.0399 1.0198e-06H48.4435V38.4427H25.0399V1.0198e-06Z" fill="white" />
    </mask>
    <g mask="url(#mask1_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.0396 38.4411C29.7089 32.3264 36.9369 32.3291 42.1062 28.6331C50.4702 22.6557 49.8209 8.02107 44.4169 -0.00026436C49.6236 27.5584 27.8636 22.8837 25.0396 38.4424"
          fill="#6941C6"
        />
      </g>
    </g>
    <mask
      id="mask2_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="25"
      y="10"
      width="14"
      height="29"
    >
      <path d="M25.0399 10.9133H38.1473V38.44H25.0399V10.9133Z" fill="white" />
    </mask>
    <g mask="url(#mask2_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M38.1471 10.9132C32.4431 16.1372 25.0391 20.6385 25.0391 38.4412C27.3657 33.4465 32.2884 30.0652 38.1471 28.3119V10.9132Z"
          fill="#42307D"
        />
      </g>
    </g>
    <path
      d="M25.0391 19.584V38.4413C27.0337 33.1747 31.2497 29.216 36.2697 26.7747V1.34401C29.6857 5.144 25.0391 11.4733 25.0391 19.584Z"
      fill="url(#paint1_linear_5509_1666)"
    />
    <mask
      id="mask3_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="25"
      y="13"
      width="11"
      height="26"
    >
      <path d="M25.0399 13.0307H35.7611V38.4413H25.0399V13.0307Z" fill="white" />
    </mask>
    <g mask="url(#mask3_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.0396 38.4411C25.0396 23.0477 30.5756 17.5997 35.7609 13.0304V26.4557C31.4729 28.6037 26.6756 32.8411 25.0396 38.4397"
          fill="#42307D"
        />
      </g>
    </g>
    <mask
      id="mask4_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="25"
      y="1"
      width="12"
      height="23"
    >
      <path d="M25.0399 1.34266H36.2704V23.224H25.0399V1.34266Z" fill="white" />
    </mask>
    <g mask="url(#mask4_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.0396 23.2237C25.0396 15.1144 29.6849 8.78373 36.2702 4.98239V1.3424C29.6849 5.14506 25.0396 11.4731 25.0396 19.5837V23.2237Z"
          fill="#B692F6"
        />
      </g>
    </g>
    <mask
      id="mask5_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="25"
      y="1"
      width="12"
      height="38"
    >
      <path d="M25.0399 1.34266H36.2704V38.4413H25.0399V1.34266Z" fill="white" />
    </mask>
    <g mask="url(#mask5_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M36.2701 1.34281V26.7748C31.2488 29.2148 27.0341 33.1748 25.0395 38.4415C26.6755 32.8428 31.4715 28.6055 35.7608 26.4575V1.64547C35.9301 1.54281 36.0995 1.44281 36.2701 1.34281Z"
          fill="#B692F6"
        />
      </g>
    </g>
    <path
      d="M6.33771 28.6333C11.507 32.3293 18.735 32.3267 23.403 38.4413C23.403 11.2573 6.14305 15.0867 4.02705 1.0198e-06C-1.37695 8.02 -2.02762 22.656 6.33771 28.6333Z"
      fill="url(#paint2_linear_5509_1666)"
    />
    <mask
      id="mask6_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="18"
      width="24"
      height="21"
    >
      <path d="M0.448669 18.2093H23.4032V38.44H0.448669V18.2093Z" fill="white" />
    </mask>
    <g mask="url(#mask6_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.4035 38.4405C18.7355 32.3272 11.5075 32.3285 6.33681 28.6339C3.12614 26.3379 1.24347 22.7659 0.448807 18.7819C8.59414 16.8219 17.1141 19.9899 22.0008 26.7952C22.8781 29.9125 23.4035 33.7045 23.4035 38.4392"
          fill="#6941C6"
        />
      </g>
    </g>
    <mask
      id="mask7_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="39"
    >
      <path d="M0.228394 0.470657H23.6316V38.9133H0.228394V0.470657Z" fill="white" />
    </mask>
    <g mask="url(#mask7_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.4035 38.4411C18.7355 32.3264 11.5075 32.3291 6.33679 28.6331C-2.02721 22.6557 -1.37654 8.02107 4.02746 -0.000268174C-1.18054 27.5584 20.5808 22.8837 23.4035 38.4424"
          fill="#7F56D9"
        />
      </g>
    </g>
    <mask
      id="mask8_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="10"
      y="10"
      width="14"
      height="29"
    >
      <path d="M10.2961 10.9133H23.4032V38.44H10.2961V10.9133Z" fill="white" />
    </mask>
    <g mask="url(#mask8_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.2961 10.9132C16.0001 16.1372 23.4041 20.6385 23.4041 38.4412C21.0761 33.4465 16.1561 30.0652 10.2961 28.3119V10.9132Z"
          fill="#42307D"
        />
      </g>
    </g>
    <path
      d="M12.1724 26.7747C17.1937 29.216 21.4097 33.1747 23.4031 38.4413V19.584C23.4031 11.4733 18.7577 5.144 12.1724 1.34401V26.7747Z"
      fill="url(#paint3_linear_5509_1666)"
    />
    <mask
      id="mask9_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="12"
      y="13"
      width="12"
      height="26"
    >
      <path d="M12.6824 13.0307H23.4032V38.4413H12.6824V13.0307Z" fill="white" />
    </mask>
    <g mask="url(#mask9_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.4035 38.4411C23.4035 23.0477 17.8688 17.5997 12.6821 13.0304V26.4557C16.9715 28.6037 21.7675 32.8411 23.4035 38.4397"
          fill="#42307D"
        />
      </g>
    </g>
    <mask
      id="mask10_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="12"
      y="1"
      width="12"
      height="23"
    >
      <path d="M12.1731 1.34266H23.4032V23.224H12.1731V1.34266Z" fill="white" />
    </mask>
    <g mask="url(#mask10_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.4035 23.2237C23.4035 15.1144 18.7581 8.78373 12.1728 4.98239V1.3424C18.7568 5.14506 23.4035 11.4731 23.4035 19.5837V23.2237Z"
          fill="#D6BBFB"
        />
      </g>
    </g>
    <mask
      id="mask11_5509_1666"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="12"
      y="1"
      width="12"
      height="38"
    >
      <path d="M12.1731 1.34266H23.4032V38.4413H12.1731V1.34266Z" fill="white" />
    </mask>
    <g mask="url(#mask11_5509_1666)">
      <g opacity="0.300003">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.1731 1.34281V26.7748C17.1944 29.2148 21.4091 33.1748 23.4037 38.4415C21.7677 32.8428 16.9717 28.6055 12.6824 26.4575V1.64547C12.5117 1.54281 12.3451 1.44147 12.1731 1.34281Z"
          fill="#D6BBFB"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5509_1666"
        x1="36.7946"
        y1="45.1312"
        x2="36.4157"
        y2="-4.95747"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7F56D9" />
        <stop offset="1" stop-color="#9E77ED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5509_1666"
        x1="30.5882"
        y1="46.8623"
        x2="32.18"
        y2="-4.84521"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#42307D" />
        <stop offset="1" stop-color="#9E77ED" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_5509_1666"
        x1="11.7547"
        y1="45.2081"
        x2="11.3759"
        y2="-4.88059"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7F56D9" />
        <stop offset="1" stop-color="#9E77ED" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5509_1666"
        x1="17.718"
        y1="46.8251"
        x2="19.1876"
        y2="-4.88897"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#42307D" />
        <stop offset="1" stop-color="#9E77ED" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '39',
    },
    width: {
      type: String,
      default: '49',
    },
    color: {
      type: String,
      default: 'label-text',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStyle: function () {
      return {
        fill: ['$' + this.color, `var(--${this.color})`],
      }
    },
  },
}
</script>
